/* Proutdoor · Combos a la vista (nov 2026). Mejora 6 del informe.
   Solo informa: el 5% lo aplica la app Combo Pesca en el carro.
   Igual que en la app: sin-combo no participa en ningún combo, y los rifles solo en Combo Caza.
   SI CAMBIAN LOS REQUISITOS en combo-pesca-app/COMBOS.md, HAY QUE ACTUALIZAR ESTA LISTA. */
(function () {
  const COMBOS = [
    {
      nombre: 'Combo Pesca',
      requisitos: [
        { coleccion: 'canas-de-pesca', cantidad: 1, texto: '1 caña', ver: 'Ver cañas' },
        { coleccion: 'carretes-de-pesca', cantidad: 1, texto: '1 carrete', ver: 'Ver carretes' },
        { coleccion: 'lineas', cantidad: 1, texto: '1 línea', ver: 'Ver líneas' },
        { coleccion: 'senuelos', cantidad: 1, texto: '1 señuelo', ver: 'Ver señuelos' }
      ]
    },
    {
      nombre: 'Combo Caza',
      aceptaRifles: true,
      requisitos: [
        { coleccion: 'aire-comprimido', cantidad: 2, texto: '2 de aire comprimido', ver: 'Ver aire comprimido' },
        { coleccion: 'opticos', cantidad: 1, texto: '1 óptico', ver: 'Ver ópticos' }
      ]
    },
    {
      nombre: 'Combo Overlander',
      requisitos: [
        { coleccion: 'overland', cantidad: 4, texto: '4 productos overland', ver: 'Ver overland' }
      ]
    },
    {
      nombre: 'Combo Kit EDC',
      requisitos: [
        { coleccion: 'navajas', cantidad: 1, texto: '1 navaja', ver: 'Ver navajas' },
        { coleccion: 'multiuso', cantidad: 1, texto: '1 multiuso', ver: 'Ver multiuso' }
      ]
    }
  ];

  const main = document.querySelector('#main-content');
  const handle = decodeURIComponent(location.pathname.split('/products/')[1] || '').replace(/\/$/, '');
  if (!main || !handle) return;

  const form = () => main.querySelector('.js-product-form-main');
  const cache = new Map();
  const VACIO = { colecciones: [], sinCombo: false, soloCaza: false };
  const datosDe = (h) => {
    if (!cache.has(h)) {
      cache.set(h, fetch(`/products/${encodeURIComponent(h)}?view=pt-colecciones`)
        .then((r) => (r.ok ? r.json() : VACIO))
        .catch(() => VACIO));
    }
    return cache.get(h);
  };

  const participa = (datos, combo) => !datos.sinCombo && (!datos.soloCaza || combo.aceptaRifles);

  let bloque = null;
  const quitar = () => bloque?.remove();

  const pintar = async () => {
    const boton = form()?.querySelector('[type="submit"]');
    if (!boton || boton.disabled) return quitar();

    const propio = await datosDe(handle);
    const posibles = COMBOS.filter((c) => participa(propio, c) &&
      c.requisitos.some((r) => propio.colecciones.includes(r.coleccion)));
    if (!posibles.length) return quitar();

    let carro;
    try {
      carro = await (await fetch('/cart.js')).json();
    } catch (e) {
      return quitar();
    }

    const lineas = [];
    for (const item of carro.items) {
      lineas.push({ datos: await datosDe(item.handle), cantidad: item.quantity });
    }
    const enCarro = carro.items.some((i) => i.handle === handle);
    if (!enCarro) {
      const cantidad = Number(form().querySelector('[name="quantity"]')?.value) || 1;
      lineas.push({ datos: propio, cantidad });
    }

    // Mismo conteo que el descuento: por unidades, solo con lo que participa en ese combo.
    const unidadesDe = (combo, coleccion) => lineas.reduce((total, l) => (
      participa(l.datos, combo) && l.datos.colecciones.includes(coleccion) ? total + l.cantidad : total
    ), 0);
    const faltan = (combo) => combo.requisitos.reduce(
      (total, r) => total + Math.max(0, r.cantidad - unidadesDe(combo, r.coleccion)), 0);
    // Si el producto sirve para más de un combo, se muestra el más cercano a completarse.
    const combo = posibles.reduce((mejor, c) => (faltan(c) < faltan(mejor) ? c : mejor));
    const hayExcluidos = lineas.some((l) => !participa(l.datos, combo));
    const alcance = hayExcluidos
      ? '5% de descuento, salvo en los productos que no participan en este combo.'
      : '5% de descuento en toda tu compra.';

    if (!bloque) {
      bloque = document.createElement('div');
      bloque.className = 'pt-combo';
    }
    if (faltan(combo) === 0) {
      bloque.innerHTML = enCarro
        ? `<p class="pt-combo__titulo">Tu carro ya tiene el ${combo.nombre}</p><p>${alcance}</p>`
        : `<p class="pt-combo__titulo">Con este producto completas el ${combo.nombre}</p><p>${alcance}</p>`;
    } else {
      const filas = combo.requisitos.map((r) => {
        const tiene = unidadesDe(combo, r.coleccion);
        if (tiene >= r.cantidad) return `<li class="is-ok"><span>✓ ${r.texto}</span></li>`;
        const avance = r.cantidad > 1 && tiene > 0 ? ` (llevas ${tiene})` : '';
        return `<li><span>${r.texto}${avance}</span><a href="/collections/${r.coleccion}">${r.ver}</a></li>`;
      }).join('');
      bloque.innerHTML = `<p class="pt-combo__titulo">Completa tu equipo y ahorra 5%</p><p>${combo.nombre}. ${alcance} Se completa con:</p><ul>${filas}</ul>`;
    }
    if (!bloque.isConnected) {
      main.querySelector('product-form')?.closest('.product-info__block')?.after(bloque);
    }
  };

  const repintar = () => setTimeout(pintar, 400);
  main.addEventListener('change', repintar);
  document.addEventListener('on:cart:add', repintar);
  document.addEventListener('on:line-item:change', repintar);
  const drawer = document.querySelector('#cart-drawer');
  if (drawer) {
    let espera;
    new MutationObserver(() => {
      clearTimeout(espera);
      espera = setTimeout(pintar, 500);
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
  pintar();
})();
